// export const BACKGOUND_CONST: any = { action: "controllerName", value: "ctrl_backgroundtonegotiation" };
// export const STAKEHOLDER_CONST: any = { action: "controllerName", value: "ctrl_stakeholders" };
// export const CULTURE_CONST: any = { action: "controllerName", value: "ctrl_culture" };
// export const NEGOTIONALITY_CONST: any = { action: "controllerName", value: "ctrl_negotionality" };
// export const THISNEGOTIAION_CONST: any = { action: "controllerName", value: "ctrl_thisnegotiation" };
// export const POWER_CONST: any = { action: "controllerName", value: "ctrl_power" };
// export const GAME_CONST: any = { action: "controllerName", value: "ctrl_game" };
// export const NEGOTIABLES_CONST: any = { action: "controllerName", value: "ctrl_negotiables" };
// export const THEIRNEGOTIABLES_CONST: any = { action: "controllerName", value: "ctrl_theirnegotiables" };
// export const CULTUREPLAN_CONST: any = { action: "controllerName", value: "ctrl_cultureplan" };
// export const PREPARATION_CONST: any = { action: "controllerName", value: "ctrl_preparation" };
// export const EVENTTIMELINE_CONST: any = { action: "controllerName", value: "ctrl_negotiationeventtimeline" };
// export const POSTEVENTACTION_CONST: any = { action: "controllerName", value: "ctrl_posteventactions" };
// export const LEARNING_CONST: any = { action: "controllerName", value: "ctrl_outcomeslearning" };

export const BACKGOUND_CONST: any = { value: "38" };
export const STAKEHOLDER_CONST: any = { value: "39" };
export const CULTURE_CONST: any = {  value: "40" };
export const NEGOTIONALITY_CONST: any = {  value: "41" };
export const THISNEGOTIAION_CONST: any = { value: "42" };
export const POWER_CONST: any = {  value: "43" };
export const GAME_CONST: any = {  value: "44" };
export const NEGOTIABLES_CONST: any = {  value: "45" };
export const THEIRNEGOTIABLES_CONST: any = {  value: "46" };
export const CULTUREPLAN_CONST: any = {  value: "47" };
export const PREPARATION_CONST: any = { value: "48" };
export const EVENTTIMELINE_CONST: any = {  value: "49" };
export const POSTEVENTACTION_CONST: any = {  value: "50" };
export const LEARNING_CONST: any = {  value: "51" };
export const LITE_BACKGROUND_CONST: any = {value: "52"};
export const LITE_MEETINGMANAGEMENT_CONST: any = {value: "53"};
export const NANO_SCOPETONEGOTIATEOBJECTIVE_CONST: any = {value: "54"};
export const NANO_NEGOTIATIONPLAN_CONST: any = {value: "55"};


// WEBPACK FOOTER //
// ./src/app/const/uri.const.ts